import { getAppStore } from '@src/utils/store-reference';

export type HelpInquiryRouteParams = {
  requestId: number;
  version: number;
  helpInquiryId: number;
};

const buildServiceRoot = () => {
  const store = getAppStore();
  return `/api/requests/${store.selectRequestID()}/versions/${store.selectVersion()}/helpInquiries`;
};

const buildHelpInquiryRoot = ({ requestId, version, helpInquiryId }: HelpInquiryRouteParams) =>
  `/api/requests/${requestId}/versions/${version}/helpInquiries/${helpInquiryId}`;

export const HelpEndpoints = {
  submitHelp: () => buildServiceRoot(),
  getHelpStatus: () => `${buildServiceRoot()}/status`,
  getHelpInquirySummary: (params: HelpInquiryRouteParams) => buildHelpInquiryRoot(params),
  updateHelpInquiryStatus: (params: HelpInquiryRouteParams) => buildHelpInquiryRoot(params),
  cancelHelpInquiry: (params: HelpInquiryRouteParams) => `${buildHelpInquiryRoot(params)}/cancel`,
};
